import { DEFAULT_GETTERS } from '@/constants'

export default {
  ...DEFAULT_GETTERS,
  listCampaign: state => state.listCampaign,
  listAdGroupSpp: state => state.listAdGroupSpp,
  listAd: state => state.listAd,

  campaignDetail: state => state.campaignDetail,
  listAdGroupCampaign: state => state.listAdGroupCampaign,
  listAdCampaignSpp: state => state.listAdCampaignSpp,
  listAdCampaignSp: state => state.listAdCampaignSp,
  listAdCampaignManual: state => state.listAdCampaignManual,

  listIdentity: state => state.listIdentity,
  listVideoTikTok: state => state.listVideoTikTok,
  listVideoCreative: state => state.listVideoCreative,
  listVideoLibrary: state => state.listVideoLibrary,

  listThumbnailVideoCreative: state => state.listThumbnailVideoCreative,

  videoSyncInfo: state => state.videoSyncInfo,

  listLocation: state => state.listLocation,
}
